// ຄຳນວນລາຍການເລກໜ້າທີ່ຈະສະແດງໃນ pagination (ຫຍໍ້ດ້ວຍ "..." ເມື່ອຈຳນວນໜ້າຫຼາຍ)
// ຕົວຢ່າງ: current=250, total=524 -> [1, '...', 248, 249, 250, 251, 252, '...', 524]
export function getPaginationRange(current, total, delta = 2) {
  if (total <= 1) return total === 1 ? [1] : [];

  const left = Math.max(2, current - delta);
  const right = Math.min(total - 1, current + delta);
  const range = [1];

  if (left > 2) range.push('...');
  for (let i = left; i <= right; i++) range.push(i);
  if (right < total - 1) range.push('...');

  range.push(total);
  return range;
}
